import React from "react";
import { Container } from "reactstrap";
import List from "./List";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { PLATFORM_NAME } from "../../CommonData/Data/constant";

const Distributor = ({ t }) => {
  document.title = t("document.title.distributor", { PLATFORM_NAME });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("breadcrumbs.distributor.list.title")}
            breadcrumbItem={t("breadcrumbs.distributor.list.breadcrumbItem")}
          />
          <List />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Distributor);
